import React, {Component} from 'react';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import TextAreaWithTabs from "../../UI/TextAreaWithTabs/TextAreaWithTabs";
import DeleteButton from "../ExampleGamesInput/ExampleGameInputButtons/DeleteButton";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import * as actionTypes from "../../../store/actions/actionTypes";
import {connect} from "react-redux";
import EditHistoryWrapper from "../../UI/EditHistoryPanel/EditHistoryWrapper";


class DesignProblemsInput extends Component {
    state = {
        design_problems: [],
        infoHovered: false,
        max_order_id: 0,
        active_histories: []
    }

    componentDidMount() {
        if (!this.props.designProblems || this.props.designProblems.length === 0) {
            this.props.designProblemUpdate([{
                user_id: this.props.userId,
                design_problem: "",
                order_id: 1
            }]);
            this.setState({max_order_id: 1})
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.designProblems && this.props.designProblems.length > 0 && !this.props.designProblems[0]['order_id']) {
            this.props.designProblemUpdate(
                this.props.designProblems.map((design_problem, index) => {
                    return {
                        ...design_problem,
                         order_id: index + 1
                    }
                })
            )
            this.setState({max_order_id: this.props.designProblems.length})
        } else if (!this.props.designProblems || this.props.designProblems.length === 0) {
            this.props.designProblemUpdate([{
                user_id: this.props.userId,
                design_problem: "",
                order_id: 1
            }]);
            this.setState({max_order_id: 1})
        }
    }

    addDesignProblem = () => {
        if (this.props.designProblems && this.props.designProblems.filter((problem) => {return !problem.deleted}).length < 6) {
            this.props.designProblemUpdate([
                ...this.props.designProblems,
                {
                    user_id: this.props.userId,
                    design_problem: "",
                    order_id: this.state.max_order_id + 1
                }]);
            this.setState({max_order_id: this.state.max_order_id + 1})
        }
    };

    handlePopoverToggle = (nextShow) => {
        this.setState({ infoHovered: nextShow });
    }

    handleHistoryChange = (historyChange) => {
        if (historyChange) {
            this.props.designProblemUpdate(
                this.props.designProblems.map((problem) => {
                    if (problem.design_problem_id === historyChange.design_problem_id) {
                        return { ...historyChange, order_id: problem.order_id }
                    } else {
                        return problem
                    }
                })
            )
        }
    }

    handleActiveHistory = (activeHistories) => {
        this.setState({active_histories: activeHistories})
    }

    render () {

        const deleteButton = (dp_order_id) => {
            return <DeleteButton
                onDelete={() => {
                    let mapped_array = this.props.designProblems.map((problem) => {
                            if (problem.order_id === dp_order_id) {
                                return {
                                    ...problem,
                                    deleted: 1
                                }
                            } else {
                                return problem
                            }
                        });
                    let filtered_array = mapped_array.filter((problem) => {
                        return problem.deleted !== 1 || problem.design_problem_id;
                    })
                    this.props.designProblemUpdate(filtered_array);
                }}
                message={"Are you sure you want to delete this design problem?"}
            />
        }

        let design_problem_inputs = ''
        if (this.props.designProblems && this.props.designProblems.length > 0) {
            design_problem_inputs = (
                <React.Fragment>
                    <dd className="col-sm-9">
                        {this.props.designProblems.filter((problem) => {return !problem.deleted}).map((problem, problem_index) => {
                            return (
                                <div className="example-games-block" key={"design-problem-entry-" + problem_index}>
                                    {this.props.designProblems.length > 1
                                        ? <React.Fragment>
                                            <div className="example-games-select-semi-full">Design
                                                Problem {problem_index + 1}</div>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "flex-end"
                                            }}><div style={{marginRight: 5}}></div>{deleteButton(problem.order_id)}</div>
                                        </React.Fragment>
                                        : ""}
                                    <div className="example-description">
                                        <TextAreaWithTabs
                                            // style={styleRedShadow(this.props.designsValid())}
                                            rows="4"
                                            placeholder="What design problem does your pattern solve?"
                                            value={problem.design_problem}
                                            onChange={(event) => {
                                                let edited_design_problem = this.props.designProblems.filter((problem) => {return !problem.deleted})[problem_index]
                                                this.props.designProblemUpdate(this.props.designProblems.map((problem) => {
                                                    if (problem.order_id === edited_design_problem.order_id) {
                                                        return {
                                                            ...edited_design_problem,
                                                            design_problem: event.target.value,
                                                        }
                                                    } else {
                                                        return problem
                                                    }
                                                }));
                                            }}
                                        />
                                        <EditHistoryWrapper
                                            token={this.props.token}
                                            history_id={problem.history_id}
                                            pattern_id={this.props.pattern_id}
                                            component_id={problem.design_problem_id}
                                            handleHistoryChange={this.handleHistoryChange}
                                            handleActiveHistory={this.handleActiveHistory}
                                            activeHistories={this.state.active_histories}
                                            component_text_field={problem.design_problem}
                                            component={problem}
                                            flag={"DESIGN_PROBLEM"}
                                            keyStr={"design-problem-history-" + problem.design_problem_id}
                                            isActive={this.state.active_histories.includes(problem.design_problem_id)}
                                            openUserModal={() => {
                                                this.props.setSelectedUserId(problem.editor_user_id);
                                                this.props.openUserModal();
                                            }}
                                        />
                                    </div>
                                </div>
                            )

                        })}
                    </dd>
                    <dt className="col-sm-3"></dt>
                </React.Fragment>
            )
        }
        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Design Problems<span style={{color: "red"}}> *</span></label></dt>
                {design_problem_inputs}
                <dd className="col-sm-9" style={{display: "inline-flex", justifyContent: "right"}}>
                    <span>
                        Add Additional Problem: <OverlayTrigger
                            rootClose
                            rootCloseEvent="click"
                            placement='bottom'
                            onToggle={(nextShow) => this.handlePopoverToggle(nextShow)}
                            overlay={
                                this.props.designProblems && this.props.designProblems.filter((problem) => {return !problem.deleted}).length < 6
                                    ? <Popover id='design-problem-add'>
                                        <Popover.Title>
                                            Add Additional Problem
                                        </Popover.Title>
                                        <Popover.Content className="game-description">
                                            Only add additional problems if you think that this pattern
                                            has either multiple different consequences, or applies in different ways under
                                            different conditions.
                                        </Popover.Content>
                                    </Popover>
                                    : <Popover id='design-problem-add-limit'>
                                        <Popover.Title>
                                            <span style={{color: 'red'}}>Cannot Add More Design Problems</span>
                                        </Popover.Title>
                                        <Popover.Content className="game-description">
                                            No more design problems can be added to this pattern. If you think this
                                            pattern solves an additional design problem, it is likely becoming too
                                            complex. Try decomposing your pattern into multiple patterns instead.
                                        </Popover.Content>
                                    </Popover>
                            }
                        >
                            <AddCircleOutlineIcon
                                onClick={this.addDesignProblem}
                                style={
                                    this.props.designProblems && this.props.designProblems.filter((problem) => {return !problem.deleted}).length < 6
                                        ? {color: this.state.infoHovered ? "#00bd00" : "green",
                                            transform: this.state.infoHovered ? 'scale(1.2)' : 'scale(1)'}
                                        : {color: "grey"}
                                }
                            />
                        </OverlayTrigger>
                    </span>
                </dd>
            </dl>
        )

    }

}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        openUserModal: () => dispatch({type: actionTypes.OPEN_USER_MODAL}),
        setSelectedUserId: (userId) => dispatch({type: actionTypes.SELECT_USER, userId: userId})
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (DesignProblemsInput);
